import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import SearchIcon from '@material-ui/icons/Search'

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    minHeight: '100%',
    flex: 1,
    padding: 8
  },
  placeholderTitle: {
    color: '#5f7aa4',
    fontSize: 20,
    fontWeight: 400
  },
  placeholderText: {
    fontSize: 16,
    maxWidth: 250,
    color: '#002D72',
    fontWeight: 'bold'
  },
  placeholderImage: {
    maxWidth: '100%',
    marginBottom: 36,
    width: 140
  }
})

const SearchResultPlaceholder = ({ classes }) => {
  return (
    <div className={classes.root}>
      <SearchIcon style={{ fontSize: 80, color: '#5f7aa4' }} />
      <Typography variant={'title'} gutterBottom className={classes.placeholderTitle}>
        Nenhum resultado para esta busca.
      </Typography>
      <Typography className={classes.placeholderText}>
        Faça busca por artigos, autores ou termos.
      </Typography>
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(SearchResultPlaceholder)
